export default __webpack_public_path__ + "static/media/FansBuy.5a058ad1.jpg";